import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { memberDashboard } from '../../../api/apiServices'

function MemberDashboard() {
	const navigate = useNavigate()

	useEffect(() => {
		const controller = new AbortController();
		const signal = controller.signal;

		memberDashboard({ signal })
			.then(res => {
				if (res.Status === "Success") {
					navigate('/home')
				} else {
					navigate('/')
				}
			})
		return () => {
			controller.abort();
		};
	}, [navigate])
}

export default MemberDashboard